// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure this CSS is integrated with your existing styles or create a new CSS file */

/* Container styling */
.container {
  margin-top: 20px;
}

/* Main content styling */
.main-content {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

/* Header styling */
.header {
  text-align: center;
  margin-bottom: 20px;
}

/* Card body styling */
.card-body {
  margin: 20px;
}

/* Table container styling */
.table-container {
  overflow-x: auto;
}

/* Table styling */
.table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.table th,
.table td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

/* Pagination styling */
.pagination {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}

.pagination button {
  margin: 0 5px;
  padding: 10px 15px;
  border: none;
  background-color: #007bff;
  color: white;
  cursor: pointer;
  border-radius: 4px;
}

.pagination button[disabled] {
  background-color: #ccc;
  cursor: not-allowed;
}

/* Select bank label styling */
.select-bank-label {
  margin-bottom: 10px;
  font-weight: bold;
}

/* Select bank select styling */
.select-bank-select {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  background-color: #f8f9fa;
  transition: border-color 0.3s ease;
}

.select-bank-select:focus {
  outline: none;
  border-color: #007bff;
}

.select-bank-select::-ms-expand {
  display: none;
}

.select-bank-select::after {
  content: "\\25BC";
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  pointer-events: none;
}

/* Export button styling */
.export-button {
  display: inline-block;
  padding: 10px 20px;
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  background-color: #007bff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  text-align: center;
  text-decoration: none;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.export-button:hover {
  background-color: #0056b3;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}

.export-button:active {
  background-color: #004494;
}

.export-button:focus {
  outline: none;
}

/* Date range selector styling */
.date-range-selector {
  margin-bottom: 20px;
}

.date-range-selector select {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  background-color: #f8f9fa;
  transition: border-color 0.3s ease;
  font-size: 16px; /* Adjust font size as needed */
}

.date-range-selector select:focus {
  outline: none;
  border-color: #007bff;
}

.date-range-selector .custom-date-range {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 10px; /* Added gap for spacing */
}

.date-range-selector .custom-date-range .form-control {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  background-color: #f8f9fa;
  transition: border-color 0.3s ease;
  font-size: 16px; /* Adjust font size as needed */
}

.date-range-selector .custom-date-range .form-control:focus {
  outline: none;
  border-color: #007bff;
}

.date-range-selector .custom-date-range .react-datepicker-wrapper {
  width: 100%;
}

.date-range-selector .custom-date-range .react-datepicker__input-container {
  width: 100%;
}

.date-range-selector .custom-date-range .react-datepicker__input-container input {
  width: 100%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  background-color: #f8f9fa;
  transition: border-color 0.3s ease;
  font-size: 16px; /* Adjust font size as needed */
}

.date-range-selector .custom-date-range .react-datepicker__input-container input:focus {
  outline: none;
  border-color: #007bff;
}

/* Modal overlay */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}

.modal-overlay.hide {
  opacity: 0;
  pointer-events: none;
}

.modal-overlay.show {
  opacity: 1;
}

/* Modal content */
.modal-content {
  background: #fff;
  padding: 30px; /* Increased padding for more space */
  border-radius: 8px;
  width: 90%;
  max-width: 700px; /* Increased max-width for better spaciousness */
  max-height: 80vh; /* Limit the height of the modal */
  overflow-y: auto; /* Add scroll if content exceeds max-height */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  position: relative;
}

/* Modal header */
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #ddd;
  padding-bottom: 15px;
}

.modal-header h2 {
  margin: 0;
  font-size: 28px; /* Increased font size for better visibility */
  color: #333;
}

.modal-header .close {
  font-size: 30px; /* Larger close button for ease of clicking */
  color: #333;
  border: none;
  background: none;
  cursor: pointer;
}

/* Modal body */
.modal-body {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px; /* Added gap for better spacing between elements */
}

/* Modal footer */
.modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  gap: 10px; /* Space between footer buttons */
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 16px; /* Adjusted font size for consistency */
  cursor: pointer;
  transition: background 0.3s;
}

.btn-primary {
  background: #007bff;
  color: #fff;
}

.btn-primary:hover {
  background: #0056b3;
}

.btn-primary:disabled {
  background: #0056b3;
  cursor: not-allowed;
}

.btn-secondary {
  background: #6c757d;
  color: #fff;
}

.btn-secondary:hover {
  background: #5a6268;
}

/* Banks list styling */
.banks-list {
  display: flex;
  flex-wrap: wrap;
  gap: 20px; /* Increased gap for better spacing */
  padding: 10px; /* Add some padding around the list */
  background-color: #f8f9fa; /* Light background for contrast */
  border-radius: 8px; /* Rounded corners for a modern look */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */
}

.banks-list .form-check {
  display: flex;
  align-items: center;
  gap: 12px; /* Space between checkbox and label */
  padding: 10px; /* Add padding for better touch targets */
  border-radius: 5px; /* Rounded corners for the list items */
  background-color: #ffffff; /* White background for individual items */
  transition: background-color 0.3s, box-shadow 0.3s; /* Smooth transitions */
  cursor: pointer; /* Pointer cursor for clickable items */
}

.banks-list .form-check:hover {
  background-color: #e9ecef; /* Light background on hover */
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); /* Slightly larger shadow on hover */
}

.banks-list .form-check input[type="checkbox"] {
  width: 20px; /* Larger checkbox for better visibility */
  height: 20px; /* Larger checkbox for better visibility */
  margin: 0; /* Remove default margin */
}

.banks-list .form-check label {
  margin: 0;
  font-size: 16px; /* Consistent font size */
  color: #333; /* Darker text color for better readability */
}

.banks-list .form-check input[type="checkbox"]:checked {
  background-color: #007bff; /* Color of the checked state */
  border-color: #007bff; /* Border color of the checked state */
}

/* Hover effects for analytics and device brand */
.android-analytics:hover {
  background: #e3e3e3 !important;
}

.sim-analytics:hover {
  background: #e3e3e3 !important;
}

.device-brand:hover {
  background: #e3e3e3 !important;
}
`, "",{"version":3,"sources":["webpack://./src/styles/BankTable.css"],"names":[],"mappings":"AAAA,qFAAqF;;AAErF,sBAAsB;AACtB;EACE,gBAAgB;AAClB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,YAAY;AACd;;AAEA,4BAA4B;AAC5B;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA,0BAA0B;AAC1B;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,4DAA4D;AAC9D;;AAEA;EACE,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;EAClC,eAAe,EAAE,+BAA+B;AAClD;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,0BAA0B;AACvC;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;EAClC,eAAe,EAAE,+BAA+B;AAClD;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EACzB,kCAAkC;EAClC,eAAe,EAAE,+BAA+B;AAClD;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,aAAa,EAAE,qCAAqC;EACpD,kBAAkB;EAClB,UAAU;EACV,gBAAgB,EAAE,gDAAgD;EAClE,gBAAgB,EAAE,kCAAkC;EACpD,gBAAgB,EAAE,6CAA6C;EAC/D,yCAAyC;EACzC,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,6BAA6B;EAC7B,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe,EAAE,8CAA8C;EAC/D,WAAW;AACb;;AAEA;EACE,eAAe,EAAE,6CAA6C;EAC9D,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS,EAAE,kDAAkD;AAC/D;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,SAAS,EAAE,iCAAiC;AAC9C;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe,EAAE,uCAAuC;EACxD,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,eAAe;EACf,SAAS,EAAE,qCAAqC;EAChD,aAAa,EAAE,qCAAqC;EACpD,yBAAyB,EAAE,kCAAkC;EAC7D,kBAAkB,EAAE,sCAAsC;EAC1D,wCAAwC,EAAE,4BAA4B;AACxE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS,EAAE,qCAAqC;EAChD,aAAa,EAAE,yCAAyC;EACxD,kBAAkB,EAAE,uCAAuC;EAC3D,yBAAyB,EAAE,0CAA0C;EACrE,kDAAkD,EAAE,uBAAuB;EAC3E,eAAe,EAAE,uCAAuC;AAC1D;;AAEA;EACE,yBAAyB,EAAE,8BAA8B;EACzD,wCAAwC,EAAE,oCAAoC;AAChF;;AAEA;EACE,WAAW,EAAE,0CAA0C;EACvD,YAAY,EAAE,0CAA0C;EACxD,SAAS,EAAE,0BAA0B;AACvC;;AAEA;EACE,SAAS;EACT,eAAe,EAAE,yBAAyB;EAC1C,WAAW,EAAE,6CAA6C;AAC5D;;AAEA;EACE,yBAAyB,EAAE,+BAA+B;EAC1D,qBAAqB,EAAE,sCAAsC;AAC/D;;AAEA,iDAAiD;AACjD;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC","sourcesContent":["/* Ensure this CSS is integrated with your existing styles or create a new CSS file */\n\n/* Container styling */\n.container {\n  margin-top: 20px;\n}\n\n/* Main content styling */\n.main-content {\n  background: #fff;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n/* Header styling */\n.header {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n/* Card body styling */\n.card-body {\n  margin: 20px;\n}\n\n/* Table container styling */\n.table-container {\n  overflow-x: auto;\n}\n\n/* Table styling */\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-bottom: 20px;\n}\n\n.table th,\n.table td {\n  padding: 12px;\n  text-align: left;\n  border-bottom: 1px solid #ddd;\n}\n\n/* Pagination styling */\n.pagination {\n  display: flex;\n  justify-content: center;\n  margin-top: 20px;\n}\n\n.pagination button {\n  margin: 0 5px;\n  padding: 10px 15px;\n  border: none;\n  background-color: #007bff;\n  color: white;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.pagination button[disabled] {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n/* Select bank label styling */\n.select-bank-label {\n  margin-bottom: 10px;\n  font-weight: bold;\n}\n\n/* Select bank select styling */\n.select-bank-select {\n  width: 100%;\n  padding: 10px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  background-color: #f8f9fa;\n  transition: border-color 0.3s ease;\n}\n\n.select-bank-select:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n.select-bank-select::-ms-expand {\n  display: none;\n}\n\n.select-bank-select::after {\n  content: \"\\25BC\";\n  position: absolute;\n  top: 50%;\n  right: 10px;\n  transform: translateY(-50%);\n  pointer-events: none;\n}\n\n/* Export button styling */\n.export-button {\n  display: inline-block;\n  padding: 10px 20px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #fff;\n  background-color: #007bff;\n  border: none;\n  border-radius: 5px;\n  cursor: pointer;\n  text-align: center;\n  text-decoration: none;\n  transition: background-color 0.3s ease, box-shadow 0.3s ease;\n}\n\n.export-button:hover {\n  background-color: #0056b3;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);\n}\n\n.export-button:active {\n  background-color: #004494;\n}\n\n.export-button:focus {\n  outline: none;\n}\n\n/* Date range selector styling */\n.date-range-selector {\n  margin-bottom: 20px;\n}\n\n.date-range-selector select {\n  width: 100%;\n  padding: 10px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  background-color: #f8f9fa;\n  transition: border-color 0.3s ease;\n  font-size: 16px; /* Adjust font size as needed */\n}\n\n.date-range-selector select:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n.date-range-selector .custom-date-range {\n  margin-top: 10px;\n  display: flex;\n  align-items: center;\n  gap: 10px; /* Added gap for spacing */\n}\n\n.date-range-selector .custom-date-range .form-control {\n  width: 100%;\n  padding: 10px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  background-color: #f8f9fa;\n  transition: border-color 0.3s ease;\n  font-size: 16px; /* Adjust font size as needed */\n}\n\n.date-range-selector .custom-date-range .form-control:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n.date-range-selector .custom-date-range .react-datepicker-wrapper {\n  width: 100%;\n}\n\n.date-range-selector .custom-date-range .react-datepicker__input-container {\n  width: 100%;\n}\n\n.date-range-selector .custom-date-range .react-datepicker__input-container input {\n  width: 100%;\n  padding: 10px;\n  border-radius: 5px;\n  border: 1px solid #ccc;\n  background-color: #f8f9fa;\n  transition: border-color 0.3s ease;\n  font-size: 16px; /* Adjust font size as needed */\n}\n\n.date-range-selector .custom-date-range .react-datepicker__input-container input:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n/* Modal overlay */\n.modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: opacity 0.3s ease;\n}\n\n.modal-overlay.hide {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.modal-overlay.show {\n  opacity: 1;\n}\n\n/* Modal content */\n.modal-content {\n  background: #fff;\n  padding: 30px; /* Increased padding for more space */\n  border-radius: 8px;\n  width: 90%;\n  max-width: 700px; /* Increased max-width for better spaciousness */\n  max-height: 80vh; /* Limit the height of the modal */\n  overflow-y: auto; /* Add scroll if content exceeds max-height */\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n  position: relative;\n}\n\n/* Modal header */\n.modal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  border-bottom: 1px solid #ddd;\n  padding-bottom: 15px;\n}\n\n.modal-header h2 {\n  margin: 0;\n  font-size: 28px; /* Increased font size for better visibility */\n  color: #333;\n}\n\n.modal-header .close {\n  font-size: 30px; /* Larger close button for ease of clicking */\n  color: #333;\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n\n/* Modal body */\n.modal-body {\n  margin-top: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px; /* Added gap for better spacing between elements */\n}\n\n/* Modal footer */\n.modal-footer {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n  gap: 10px; /* Space between footer buttons */\n}\n\n.btn {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  font-size: 16px; /* Adjusted font size for consistency */\n  cursor: pointer;\n  transition: background 0.3s;\n}\n\n.btn-primary {\n  background: #007bff;\n  color: #fff;\n}\n\n.btn-primary:hover {\n  background: #0056b3;\n}\n\n.btn-primary:disabled {\n  background: #0056b3;\n  cursor: not-allowed;\n}\n\n.btn-secondary {\n  background: #6c757d;\n  color: #fff;\n}\n\n.btn-secondary:hover {\n  background: #5a6268;\n}\n\n/* Banks list styling */\n.banks-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px; /* Increased gap for better spacing */\n  padding: 10px; /* Add some padding around the list */\n  background-color: #f8f9fa; /* Light background for contrast */\n  border-radius: 8px; /* Rounded corners for a modern look */\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* Subtle shadow for depth */\n}\n\n.banks-list .form-check {\n  display: flex;\n  align-items: center;\n  gap: 12px; /* Space between checkbox and label */\n  padding: 10px; /* Add padding for better touch targets */\n  border-radius: 5px; /* Rounded corners for the list items */\n  background-color: #ffffff; /* White background for individual items */\n  transition: background-color 0.3s, box-shadow 0.3s; /* Smooth transitions */\n  cursor: pointer; /* Pointer cursor for clickable items */\n}\n\n.banks-list .form-check:hover {\n  background-color: #e9ecef; /* Light background on hover */\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1); /* Slightly larger shadow on hover */\n}\n\n.banks-list .form-check input[type=\"checkbox\"] {\n  width: 20px; /* Larger checkbox for better visibility */\n  height: 20px; /* Larger checkbox for better visibility */\n  margin: 0; /* Remove default margin */\n}\n\n.banks-list .form-check label {\n  margin: 0;\n  font-size: 16px; /* Consistent font size */\n  color: #333; /* Darker text color for better readability */\n}\n\n.banks-list .form-check input[type=\"checkbox\"]:checked {\n  background-color: #007bff; /* Color of the checked state */\n  border-color: #007bff; /* Border color of the checked state */\n}\n\n/* Hover effects for analytics and device brand */\n.android-analytics:hover {\n  background: #e3e3e3 !important;\n}\n\n.sim-analytics:hover {\n  background: #e3e3e3 !important;\n}\n\n.device-brand:hover {\n  background: #e3e3e3 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
